// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"298":"930b745469380c79","773":"c011478bd1f0ab1b"}[chunkId] + ".js";
};